// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================
   tufte design system — colors, type, spacing, semantic styles
   These tokens are now the production source of truth; see
   docs/design-system.md for the preserved design rationale. Fonts are loaded
   via <link> in index.html (not an @import here) so the css-loader never has
   to resolve a remote url.
   ============================================================= */

/* ---------- Tokens — dark mode (default) ---------- */
:root {
  /* Surfaces */
  --bg:         #0e0e0d;   /* page — warm near-black, NOT pure black */
  --surface:    #171715;   /* sticky headers, menus — 6% step over bg */
  --surface-2:  #1d1c1a;   /* table headers, code blocks — used sparingly */

  /* Ink */
  --fg:         #e8e3d5;   /* primary text — warm paper inverted */
  --muted:      #8a857a;   /* labels, units, sources, secondary */
  --faint:      #4a4842;   /* timestamps, very low priority */

  /* Lines */
  --rule:       #2a2926;   /* the single hairline color, 1px everywhere */
  --rule-strong:#403e39;   /* slightly stronger rule for table edges */

  /* The accent — one red, used as a mark not a decoration */
  --accent:     #c1432e;
  --accent-hover:#d34d36;
  --accent-faint:#3a1814;  /* bg behind selected rows, never as fill elsewhere */

  /* Data — three steps. Differentiate by line-weight, not hue */
  --data-1:     #e8e3d5;
  --data-2:     #8a857a;
  --data-3:     #c1432e;
  --positive:   #6fa37a;
  --negative:   #c1432e;

  /* ---------- Type ---------- */
  --font-sans:  "Geist", ui-sans-serif, system-ui, sans-serif;
  --font-mono:  "Geist Mono", ui-monospace, "SF Mono", Menlo, monospace;

  --t-12: 12px;
  --t-13: 13px;
  --t-14: 14px;
  --t-15: 15px;
  --t-16: 16px;
  --t-19: 19px;
  --t-24: 24px;
  --t-32: 32px;
  --t-48: 48px;

  --lh-tight: 1.2;
  --lh-base:  1.55;
  --lh-loose: 1.7;

  --tracking-tight: -0.01em;
  --tracking-base:  0em;
  --tracking-mono:  0em;
  --tracking-label: 0.04em;

  --weight-regular: 400;
  --weight-medium:  500;
  --weight-bold:    600;

  /* ---------- Spacing — 8px base ---------- */
  --s-0:    0px;
  --s-2:    2px;
  --s-4:    4px;
  --s-8:    8px;
  --s-12:  12px;
  --s-16:  16px;
  --s-24:  24px;
  --s-32:  32px;
  --s-48:  48px;
  --s-64:  64px;
  --s-96:  96px;
  --s-128:128px;

  /* ---------- Radius — minimal ---------- */
  --radius-0: 0px;
  --radius-1: 2px;   /* the only radius you should reach for */

  /* ---------- Motion ---------- */
  --dur-fast:  80ms;
  --dur-base: 120ms;
  --dur-slow: 200ms;
  --ease:     cubic-bezier(0.2, 0, 0, 1);

  /* ---------- Z ---------- */
  --z-base: 0;
  --z-sticky: 10;
  --z-menu: 100;
  --z-modal: 1000;

  color-scheme: dark;
}

/* ---------- Tokens — light mode ---------- */
:root[data-theme="light"],
:root.light {
  --bg:         #fbf7ec;
  --surface:    #f3eedf;
  --surface-2:  #ece6d3;

  --fg:         #1a1814;
  --muted:      #6f6a5e;
  --faint:      #b3ad9b;

  --rule:       #d8d2c2;
  --rule-strong:#bdb5a0;

  --accent:     #b8392b;
  --accent-hover:#a02f23;
  --accent-faint:#f0ddd6;

  --data-1:     #1a1814;
  --data-2:     #6f6a5e;
  --data-3:     #b8392b;
  --positive:   #4a7a55;
  --negative:   #b8392b;

  color-scheme: light;
}

/* Respect OS preference only when no explicit override is set */
@media (prefers-color-scheme: light) {
  :root:not([data-theme]):not(.dark) {
    --bg:         #fbf7ec;
    --surface:    #f3eedf;
    --surface-2:  #ece6d3;
    --fg:         #1a1814;
    --muted:      #6f6a5e;
    --faint:      #b3ad9b;
    --rule:       #d8d2c2;
    --rule-strong:#bdb5a0;
    --accent:     #b8392b;
    --accent-hover:#a02f23;
    --accent-faint:#f0ddd6;
    --data-1:     #1a1814;
    --data-2:     #6f6a5e;
    --data-3:     #b8392b;
    --positive:   #4a7a55;
    --negative:   #b8392b;
    color-scheme: light;
  }
}

/* ---------- Semantic element defaults ---------- */
html { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }

body {
  background: var(--bg);
  color: var(--fg);
  font-family: var(--font-sans);
  font-size: var(--t-15);
  line-height: var(--lh-base);
  letter-spacing: var(--tracking-base);
  margin: 0;
}

::selection { background: var(--accent); color: var(--bg); }
`, "",{"version":3,"sources":["webpack://./src/style/tokens.css"],"names":[],"mappings":"AAAA;;;;;;kEAMkE;;AAElE,uDAAuD;AACvD;EACE,aAAa;EACb,qBAAqB,IAAI,2CAA2C;EACpE,qBAAqB,IAAI,4CAA4C;EACrE,qBAAqB,IAAI,gDAAgD;;EAEzE,QAAQ;EACR,qBAAqB,IAAI,uCAAuC;EAChE,qBAAqB,IAAI,sCAAsC;EAC/D,qBAAqB,IAAI,kCAAkC;;EAE3D,UAAU;EACV,qBAAqB,IAAI,8CAA8C;EACvE,qBAAqB,IAAI,2CAA2C;;EAEpE,0DAA0D;EAC1D,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB,GAAG,qDAAqD;;EAE9E,8DAA8D;EAC9D,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,+BAA+B;EAC/B,2DAA2D;EAC3D,qEAAqE;;EAErE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;;EAExB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,6CAA6C;EAC7C,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;;EAEb,2CAA2C;EAC3C,eAAe;EACf,eAAe,IAAI,yCAAyC;;EAE5D,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;;EAEtC,4BAA4B;EAC5B,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;;EAEf,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,qBAAqB;EACrB,qBAAqB;;EAErB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;;EAEtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE;IACE,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA,oDAAoD;AACpD,OAAO,mCAAmC,EAAE,kCAAkC,EAAE;;AAEhF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC,SAAS;AACX;;AAEA,cAAc,yBAAyB,EAAE,gBAAgB,EAAE","sourcesContent":["/* =============================================================\n   tufte design system — colors, type, spacing, semantic styles\n   These tokens are now the production source of truth; see\n   docs/design-system.md for the preserved design rationale. Fonts are loaded\n   via <link> in index.html (not an @import here) so the css-loader never has\n   to resolve a remote url.\n   ============================================================= */\n\n/* ---------- Tokens — dark mode (default) ---------- */\n:root {\n  /* Surfaces */\n  --bg:         #0e0e0d;   /* page — warm near-black, NOT pure black */\n  --surface:    #171715;   /* sticky headers, menus — 6% step over bg */\n  --surface-2:  #1d1c1a;   /* table headers, code blocks — used sparingly */\n\n  /* Ink */\n  --fg:         #e8e3d5;   /* primary text — warm paper inverted */\n  --muted:      #8a857a;   /* labels, units, sources, secondary */\n  --faint:      #4a4842;   /* timestamps, very low priority */\n\n  /* Lines */\n  --rule:       #2a2926;   /* the single hairline color, 1px everywhere */\n  --rule-strong:#403e39;   /* slightly stronger rule for table edges */\n\n  /* The accent — one red, used as a mark not a decoration */\n  --accent:     #c1432e;\n  --accent-hover:#d34d36;\n  --accent-faint:#3a1814;  /* bg behind selected rows, never as fill elsewhere */\n\n  /* Data — three steps. Differentiate by line-weight, not hue */\n  --data-1:     #e8e3d5;\n  --data-2:     #8a857a;\n  --data-3:     #c1432e;\n  --positive:   #6fa37a;\n  --negative:   #c1432e;\n\n  /* ---------- Type ---------- */\n  --font-sans:  \"Geist\", ui-sans-serif, system-ui, sans-serif;\n  --font-mono:  \"Geist Mono\", ui-monospace, \"SF Mono\", Menlo, monospace;\n\n  --t-12: 12px;\n  --t-13: 13px;\n  --t-14: 14px;\n  --t-15: 15px;\n  --t-16: 16px;\n  --t-19: 19px;\n  --t-24: 24px;\n  --t-32: 32px;\n  --t-48: 48px;\n\n  --lh-tight: 1.2;\n  --lh-base:  1.55;\n  --lh-loose: 1.7;\n\n  --tracking-tight: -0.01em;\n  --tracking-base:  0em;\n  --tracking-mono:  0em;\n  --tracking-label: 0.04em;\n\n  --weight-regular: 400;\n  --weight-medium:  500;\n  --weight-bold:    600;\n\n  /* ---------- Spacing — 8px base ---------- */\n  --s-0:    0px;\n  --s-2:    2px;\n  --s-4:    4px;\n  --s-8:    8px;\n  --s-12:  12px;\n  --s-16:  16px;\n  --s-24:  24px;\n  --s-32:  32px;\n  --s-48:  48px;\n  --s-64:  64px;\n  --s-96:  96px;\n  --s-128:128px;\n\n  /* ---------- Radius — minimal ---------- */\n  --radius-0: 0px;\n  --radius-1: 2px;   /* the only radius you should reach for */\n\n  /* ---------- Motion ---------- */\n  --dur-fast:  80ms;\n  --dur-base: 120ms;\n  --dur-slow: 200ms;\n  --ease:     cubic-bezier(0.2, 0, 0, 1);\n\n  /* ---------- Z ---------- */\n  --z-base: 0;\n  --z-sticky: 10;\n  --z-menu: 100;\n  --z-modal: 1000;\n\n  color-scheme: dark;\n}\n\n/* ---------- Tokens — light mode ---------- */\n:root[data-theme=\"light\"],\n:root.light {\n  --bg:         #fbf7ec;\n  --surface:    #f3eedf;\n  --surface-2:  #ece6d3;\n\n  --fg:         #1a1814;\n  --muted:      #6f6a5e;\n  --faint:      #b3ad9b;\n\n  --rule:       #d8d2c2;\n  --rule-strong:#bdb5a0;\n\n  --accent:     #b8392b;\n  --accent-hover:#a02f23;\n  --accent-faint:#f0ddd6;\n\n  --data-1:     #1a1814;\n  --data-2:     #6f6a5e;\n  --data-3:     #b8392b;\n  --positive:   #4a7a55;\n  --negative:   #b8392b;\n\n  color-scheme: light;\n}\n\n/* Respect OS preference only when no explicit override is set */\n@media (prefers-color-scheme: light) {\n  :root:not([data-theme]):not(.dark) {\n    --bg:         #fbf7ec;\n    --surface:    #f3eedf;\n    --surface-2:  #ece6d3;\n    --fg:         #1a1814;\n    --muted:      #6f6a5e;\n    --faint:      #b3ad9b;\n    --rule:       #d8d2c2;\n    --rule-strong:#bdb5a0;\n    --accent:     #b8392b;\n    --accent-hover:#a02f23;\n    --accent-faint:#f0ddd6;\n    --data-1:     #1a1814;\n    --data-2:     #6f6a5e;\n    --data-3:     #b8392b;\n    --positive:   #4a7a55;\n    --negative:   #b8392b;\n    color-scheme: light;\n  }\n}\n\n/* ---------- Semantic element defaults ---------- */\nhtml { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }\n\nbody {\n  background: var(--bg);\n  color: var(--fg);\n  font-family: var(--font-sans);\n  font-size: var(--t-15);\n  line-height: var(--lh-base);\n  letter-spacing: var(--tracking-base);\n  margin: 0;\n}\n\n::selection { background: var(--accent); color: var(--bg); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
